// routes
import { PATH_JOBS, PATH_PAY, PATH_SETTINGS } from '../../../routes/paths';
// components
import SvgIconStyle from '../../../components/SvgIconStyle';

// ----------------------------------------------------------------------

const getIcon = (name) => <SvgIconStyle src={`/icons/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const ICONS = {
  kanban: getIcon('ic_kanban'),
  pay: getIcon('ic_user'),
  invoice: getIcon('ic_invoice'),
};

const navConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: 'app',
    items: [
      { title: '모집공고', path: PATH_JOBS.root, icon: ICONS.kanban },
      { title: '상품결제', path: PATH_PAY.root, icon: ICONS.pay },
      { title: '설정', path: PATH_SETTINGS.root, icon: ICONS.invoice },
    ],
  },
  // APP
  // ----------------------------------------------------------------------
  // import Label from '../../../components/Label';
  // {
  //   subheader: 'app',
  //   items: [
  //     {
  //       title: 'mail',
  //       path: PATH_WORKS.root,
  //       icon: ICONS.user,
  //       info: (
  //         <Label variant="outlined" color="error">
  //           +32
  //         </Label>
  //       ),
  //     },
  //     { title: 'chat', path: PATH_WORKS.root, icon: ICONS.user },
  //     { title: 'calendar', path: PATH_WORKS.root, icon: ICONS.invoice },
  //     { title: 'kanban', path: PATH_WORKS.root, icon: ICONS.kanban },
  //   ],
  // },
];

export default navConfig;
